import RedesignDescriptor from './rewardsStatus-redesign';
import RefiveDescriptor from './rewardsStatus-refive';
import CanteenDescriptor from './rewardsStatus-canteen';
import CompanyKitchenDescriptor from './rewardsStatus-companykitchen';
import AramarkDescriptor from './rewardsStatus-aramark';
import Settings from 'src/Settings';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';

const typeDescriber = {
  [BuildTypeEnum.aramark]: AramarkDescriptor,
  [BuildTypeEnum.canteen]: CanteenDescriptor,
  [BuildTypeEnum.default]: RedesignDescriptor,
  [BuildTypeEnum.companykitchen]: CompanyKitchenDescriptor,
  [BuildTypeEnum.refive]: RefiveDescriptor,
};

export function getDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
